import React, { ReactElement } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import { FormRow } from '../../../../1stlog-ui/src/components/Bootstrap'
import Card from '../../../../1stlog-ui/src/components/Card'
import useFieldValue from '../../../../1stlog-ui/src/components/Field/useFieldValue'
import { SubmitButton } from '../../../../1stlog-ui/src/components/Form'
import Colis from '../../../../shipmetrics-shared/containers/OrderEntry/Form/Colis'
import Overview from '../../../../shipmetrics-shared/containers/OrderEntry/Form/Shipment/Overview'
import { TOrderEntrySettings } from '../../../../shipmetrics-shared/containers/OrderEntry/types'
import { TReturnAppReceiver } from '../TReturnApp'
import Address from './Address'
import LabelActivator from './LabelActivator'
import LabelActivatedMessage from './LabelActivator/LabelActivatedMessage'
import LabelEmail from './LabelEmail'
import Reason from './Reason'
import ShipmentSearch from './ShipmentSearch'

type TFormProps = {
  receiver: TReturnAppReceiver
  error: ReactElement | undefined
  settings: TOrderEntrySettings
}

const Form = (props: TFormProps): ReactElement => {
  const { receiver, error, settings } = props

  const isLabelActivated = useFieldValue('isLabelActivated')

  return (
    <>
      <Container fluid>
        <Row>
          <Col>
            <Card noHeader>
              <h3>{i18n.t('retourenreceiver', 'Retourenempfänger')}</h3>
              {receiver.returntitle || receiver.name}
            </Card>
          </Col>
        </Row>
        {error}
        <Row>
          <Col md={7} xs={12}>
            <Card noHeader>
              <h3>{i18n.t('senderinfo', 'Versenderinformationen')}</h3>
              <LabelActivator shortcode={receiver.shortcode} />
              <ShipmentSearch />
              <FormRow>
                <Col>
                  <Address />
                </Col>
              </FormRow>
              <LabelEmail />
            </Card>
          </Col>
          <Col md={5} xs={12}>
            <Reason />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card noHeader>
              <h3>{i18n.t('shipmentinfo', 'Sendungsinformationen')}</h3>
              <LabelActivatedMessage />
              <Row>
                <Col>
                  <Overview
                    totalWeightTooltip={
                      settings.constantOrderEntryProduct?.isWeightHidden
                        ? i18n.t(
                            'weight_fixed_by_provider',
                            'Das Gewicht wurde von Ihrem Dienstleister fixiert',
                          )
                        : undefined
                    }
                    disableColiCountChange={Boolean(isLabelActivated)}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Colis
                    withoutCard
                    disableColiCountChange={Boolean(isLabelActivated)}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-end">
            <SubmitButton ignoreValidation>
              {i18n.t('submit_return_order', 'Retourenerfassung abschliessen')}
            </SubmitButton>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Form
